import React from "react";
import MasrufatList from "./MasrufatList";

const MasrufatAll = () => {
  return (
    <>
      <MasrufatList />
    </>
  );
};

export default MasrufatAll;
